  export default function stripHtml(value) {	
    const div = document.createElement('div');
    div.innerHTML = value;    
    const text = div.textContent || div.innerText || '';
    return text;
}